import React, { useEffect, useState } from "react";
import { Button, TextField } from "@mui/material";
import ErrorBar from "../../Error";
import { ImportStats } from "../../GlobelStats/GlobelStats";
import { useNavigate } from "react-router-dom";
import './inputStyles.css'

const Solana = () => {
  const { 
    qrCodeSettings,
    setQrCodeSettings,
    isMobile,
    setActiveStep,
    iframe
   } = ImportStats();
  const [value, setValue] = useState(qrCodeSettings.inputData.Solana.value);
  const [qrName, setQrName] = useState(qrCodeSettings.qrName);
  const [addressError, setAddressError] = useState("");
  const [nameError, setNameError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    setValue(qrCodeSettings.inputData.Solana.value);
    setQrName(qrCodeSettings.qrName);
  }, [qrCodeSettings]);

  const handleInputChange = (event) => {
    setValue(event.target.value);
    setAddressError("");
  };

  const handleQRNameChange = (event) => {
    setQrName(event.target.value);
    setNameError("");
  };

  const handleSubmit = () => {
    // Regular expression for Solana wallet address validation
    const solanaAddressRegex = /^([A-Za-z0-9]{44}|[A-Za-z0-9]{64})$/;
  
    if (!value.trim()) {
      setAddressError("Please enter a Solana wallet address");
      return;
    }
    if (!solanaAddressRegex.test(value)) {
      setAddressError("Please enter a valid Solana wallet address");
      return;
    }
    if (!qrName.trim()) {
      setNameError("Name should not be empty");
      return;
    }
  
    // Update QR code settings
    setQrCodeSettings((prevSettings) => ({
      ...prevSettings,
      inputData: {
        ...prevSettings.inputData,
        Solana: { value: value }, 
      },
      qrName: qrName.trim(),
    }));
  
    // Navigate to the next step
    navigate('/create/input/design');
    setActiveStep(2);
  };
  

  return (
    <div>
      <div className={iframe ? "heading-container-iframe" : "heading-container"}>
        <span className={iframe ? "heading-2-iframe" : "heading-2"}>Create Your Solana Wallet Address QR Code</span>
      </div>
      <div className="option-container-home">
        {addressError && <ErrorBar message={addressError} />}
        {nameError && <ErrorBar message={nameError} />}
        <TextField
          required
          label="Write Your QR Name"
          value={qrName}
          onChange={handleQRNameChange}
          fullWidth
          margin="normal"
          className={iframe ? "input": ''}
        />
        <TextField
          required
          label="Enter Solana Wallet Address"
          value={value}
          onChange={handleInputChange}
          fullWidth
          margin="normal"
          className={iframe ? "input": ''}
        />
        <Button variant="contained" onClick={handleSubmit} className="button">
          Submit
        </Button>
      </div>
    </div>
  );
};

export default Solana;
